<template>
  <div class="site-page">
    <div v-if="loading" class="loading">Loading...</div>
    <div v-else-if="siteData" class="site-content">
      <!-- Render site specific data -->
      <h1>{{ siteData.name }}</h1>
      <p>Location: {{ siteData.Location }}</p>
      <!-- Add more site specific content here -->
      <pre>{{ JSON.stringify(siteData, null, 2) }}</pre>
    </div>
    <div v-else class="default-content">
      <h1>Welcome to Fly Social</h1>
      <p>This site is not configured yet.</p>
    </div>
  </div>
</template>

<script>
import { db } from "@/utils/firebase.utils.js";
import { doc, getDoc } from "firebase/firestore";

export default {
  name: "SitePage",
  data() {
    return {
      loading: true,
      siteData: null,
      originalFavicons: [],
    };
  },
  methods: {
    updateFavicon(favUrl) {
      // Store all original favicon elements if not already stored
      if (this.originalFavicons.length === 0) {
        this.originalFavicons = Array.from(
          document.querySelectorAll(
            "link[rel*='icon'], link[rel='shortcut icon']"
          )
        );
      }

      // Remove all existing favicon related links
      document
        .querySelectorAll("link[rel*='icon'], link[rel='shortcut icon']")
        .forEach((el) => el.remove());

      // Create and add new favicon links
      const iconTypes = ["icon", "shortcut icon", "apple-touch-icon"];
      iconTypes.forEach((type) => {
        const link = document.createElement("link");
        link.rel = type;
        link.href = favUrl;
        document.head.appendChild(link);
      });

      // Force favicon refresh
      const favicon = document.querySelector("link[rel*='icon']");
      if (favicon) {
        favicon.href = favUrl + "?v=" + new Date().getTime();
      }
    },
    restoreOriginalFavicon() {
      // Remove current favicons
      document
        .querySelectorAll("link[rel*='icon'], link[rel='shortcut icon']")
        .forEach((el) => el.remove());

      // Restore original favicons
      this.originalFavicons.forEach((favicon) => {
        document.head.appendChild(favicon.cloneNode(true));
      });
    },
  },
  async created() {
    try {
      const hostname = window.location.hostname;
      const domainParts = hostname.split(".");

      if (domainParts[0] === "site" && domainParts[1]) {
        // Query the unique_domain collection with the second part of the domain
        const domainRef = doc(db, "unique_domain", domainParts[1]);
        const docSnap = await getDoc(domainRef);

        if (docSnap.exists()) {
          this.siteData = docSnap.data();
          // Update favicon if fav_url exists
          if (this.siteData.fav_url) {
            this.$nextTick(() => {
              this.updateFavicon(this.siteData.fav_url);
            });
          }
        }
      }
    } catch (error) {
      console.error("Error fetching site data:", error);
    } finally {
      this.loading = false;
    }
  },
  beforeDestroy() {
    // Restore original favicon when component is destroyed
    this.restoreOriginalFavicon();
  },
};
</script>

<style scoped>
.site-page {
  padding: 2rem;
}

.loading {
  text-align: center;
  padding: 2rem;
}

.default-content {
  text-align: center;
  padding: 2rem;
}
</style>
